/**
 * The signed-in user for mockup mode — Sarah Chen, admin.
 * Used by AppContext and anywhere a "me" reference is needed.
 */

export interface CurrentUser {
  id: string;
  name: string;
  email: string;
  role: 'admin' | 'member';
  businessUnitId: string;
  timezone: string;
  dateFormat: string;
}

export const CURRENT_USER = {
  id: 'emp-sarah-chen',
  name: 'Sarah Chen',
  email: 'schen@firm.com',
  role: 'admin',
  businessUnitId: 'bu-corporate',
  timezone: 'America/New_York',
  dateFormat: 'MMM D, YYYY',
} as const satisfies CurrentUser;
